// extracted by mini-css-extract-plugin
export default {"inARow":"OrdersTable_inARow__U8LRx","notOnMobile":"OrdersTable_notOnMobile__Q7JVp","\t":"OrdersTable_-__f+5WR","tableContainerHolder":"OrdersTable_tableContainerHolder__9q863"};